import React, { useContext, useEffect, useState } from 'react'
import { LangContext } from '../../context/lang-context'
import { LoaderContext } from '../../context/loader-context'
import axios from 'axios'

import { NotificationManager } from 'react-notifications'
import ReCAPTCHA from 'react-google-recaptcha'

import logo from '../../assets/images/logo-retail24.png'
import { API_URL, SHOP_URL } from '../../config/config'
import Loader from '../../components/Loader/Loader'
import moment from 'moment'
import plFlag from "../../assets/flags/pl.png"
import gbFlag from "../../assets/flags/gb.png"

const Login = ({ login, setPermission }) => {
    const shouldUseRecaptcha = window.location.hostname !== 'localhost' && process.env.REACT_APP_LOCAL_DB === 'false';
    const { loader, incrementRequests, decrementRequests } = useContext(LoaderContext)
    const [token, setToken] = useState("")
    const { changeLanguage, TRL_Pack } = useContext(LangContext)
    const [isVerified, setIsVerified] = useState(false);
    const [blockedTime, setBlockedTime] = useState({
        start: null,
        end: null,
        duration: null
    })
    const [text, setText] = useState("")

    const grecaptchaObject = window.grecaptcha;

    const handleSubmit = async evt => {
        evt.preventDefault();

        const { email, password, clientId } = evt.target.elements;
        const emailValue = email.value.toLowerCase();
        const clientIdValue = clientId.value.toLowerCase();

        if (!emailValue || !password.value) return;

        incrementRequests();

        try {
            const res = await axios.put(`${API_URL}/api/auth/login`, {
                Email: emailValue,
                Password: password.value,
                ClientId: clientIdValue,
                token
            });

            localStorage.setItem(
                'lastLogin',
                JSON.stringify({
                    email: emailValue,
                    clientId: clientIdValue
                })
            );

            if (window.location.hostname === 'localhost') {
                if (clientIdValue === 'console') {
                    sessionStorage.setItem('ConsoleUser', JSON.stringify({ email: emailValue, password: password.value}));
                } else {
                    sessionStorage.setItem('DevUser', JSON.stringify({ email: emailValue, password: password.value}));
                }
            }

            setToken('');

            if (shouldUseRecaptcha && grecaptchaObject) {
                grecaptchaObject.reset();

                if (
                    res.headers['Origin'] === 'http://localhost:3001' ||
                    res.headers['Origin'] === 'http://localhost:3000' ||
                    res.headers['Access-Control-Allow-Origin'] === 'https://portal.retail24.pl' ||
                    res.headers['Access-Control-Allow-Origin'] === 'https://portal.retail24.pl:10000' ||
                    res.headers['Access-Control-Allow-Origin'] === 'https://portal.retail24.pl.test'
                ) {
                    axios.defaults.baseURL = res.headers['Origin'];
                }

                setIsVerified(true);
            }

            if (clientIdValue === 'console') {
                sessionStorage.removeItem('permissions');
                setPermission([]);
                login(res.data.token, clientIdValue);
                return;
            }

            const permissionsRes = await axios.get(`${API_URL}/api/user-permissions`, {
                headers: {
                    Authorization: `Bearer ${res.data.token}`,
                    'X-Client-Id': clientIdValue
                }
            });

            const permissions = permissionsRes?.data || [];

            setPermission(permissions);
            sessionStorage.setItem('permissions', JSON.stringify(permissions));

            login(res.data.token, clientIdValue);
        } catch (e) {
            const err = e.response;

            if (e.message === 'Network Error') {
                setText('Podczas logowania występił problem. Prosimy o zgłoszeniu do serwisu');
                setTimeout(() => {
                    setText('');
                }, 20000);
            } else if (err?.status === 429) {
                const duration = err?.data?.message?.blockDuration;
                const message = err?.data?.message?.msg;

                if (Object.values(blockedTime).some(i => !i) && duration) {
                    const d = moment.duration(duration);
                    setText(
                        `Ilość prób logowania wyczerpana, sprobój ponownie za ${
                            d.minutes() ? `${d.minutes()} minuty` : ''
                        } ${d.seconds()} sekund`
                    );

                    setTimeout(() => {
                        setText('');
                    }, duration);
                }

                if (message) {
                    NotificationManager.error(message);
                }
            } else if (err?.status > 299) {
                NotificationManager.error(
                    Object.values(err?.data || {})[0] || 'Błąd logowania'
                );
            }

            setIsVerified(false);

            if (shouldUseRecaptcha && grecaptchaObject) {
                grecaptchaObject.reset();
            }
        } finally {
            decrementRequests();
        }
    };

    useEffect(() => {
        if (process.env.REACT_APP_LOCAL_DB === "true") {
            const timeout = setTimeout(() => {
                window.location.replace(SHOP_URL);
            }, 40000);
            return () => {
                clearTimeout(timeout);
            };
        }
    }, []);


    const handleVerify = async (value) => {
        if (value) {
            setToken(value)
            setIsVerified(true)
        }
    };
    return (
        <>
            {loader && <Loader />}
            <div className="col col-md-6 col-lg-5 mx-auto d-flex align-items-center"

            >
                <div className="container">
                    {process.env.REACT_APP_LOCAL_DB === "true" && (
                        <a href={SHOP_URL}>
                            Wróć
                        </a>)}
                    {text && (
                        <div className='w-100 d-flex align-items-center'
                             style={{ background: "#EFE282", height: "50px", paddingLeft: "5px" }}>
                            <b>{text}</b>
                        </div>
                    )}
                    <div className="card card-body bg-fade mb-4">
                        <div className="text-center mt-2 mb-3">
                            <img src={logo} alt="logo" height="80" />
                        </div>
                        <form onSubmit={handleSubmit} autoComplete="off">
                            <div className="form-group">
                                <label className="small">{TRL_Pack.auth.email}</label>
                                <input
                                    type="email"
                                    name="email"
                                    className="form-control"
                                    required
                                />
                            </div>
                            <div className="form-group">
                                <label className="small">{TRL_Pack.auth.password}</label>
                                <input
                                    type="password"
                                    name="password"
                                    defaultValue=""
                                    autoComplete="off"
                                    className="form-control"
                                    required
                                    autoFocus
                                />
                            </div>
                            <div className="form-group">
                                <label className="small">{TRL_Pack.auth.clientId}</label>
                                <input
                                    type="text"
                                    name="clientId"
                                    className="form-control"
                                    defaultValue={process.env.REACT_APP_LOCAL_DB === "false" ? (sessionStorage.getItem("clientId") || "") : ""}
                                    disabled={process.env.REACT_APP_LOCAL_DB === "true"}
                                    autoCapitalize="none"
                                    required
                                />
                            </div>
                            {shouldUseRecaptcha ? (
                                <div className='mb-2 d-flex justify-content-center'>
                                    <ReCAPTCHA
                                        sitekey={"6LfIxKMpAAAAALIFN0aeEXcoxT0fUbQzq_3-0rjS"}
                                        onChange={handleVerify}
                                    />
                                </div>
                            ) : null}
                            <button className="btn btn-success btn-block" disabled={shouldUseRecaptcha ? !isVerified : false}>
                                {TRL_Pack.buttons.login}
                            </button>
                        </form>
                    </div>
                    {process.env.REACT_APP_LOCAL_DB === "true" && (
                        <div className="text-center">
                            <button
                                className="btn btn-link p-0 mx-3 rounded-circle"
                                onClick={changeLanguage('en')}
                            >
                                <img className="flag" src={gbFlag} alt="en_flag" />
                            </button>
                            <button
                                className="btn btn-link p-0 mx-3 rounded-circle"
                                onClick={changeLanguage('pl')}
                            >
                                <img className="flag" src={plFlag} alt="pl_flag" />
                            </button>
                        </div>
                    )}
                </div>
            </div>
        </>
    )
};

export default Login;
